import { binToPackedString } from '../encoding/hex-strings';

const zeroHash = new Uint8Array(20);
const zeroString = binToPackedString(zeroHash, 0, 20);

export class ResourceHashes {

	constructor(initialData) {
		if (initialData) {
			this.hashes = initialData.hashes;
			this.byteStride = initialData.byteStride;
			this.version = initialData.version;
			this.numLoaded = initialData.numLoaded;
			this.hashToIndex = initialData.hashToIndex;
		} else {
			this.hashes = [zeroString];
			this.byteStride = 20;
			this.version = 0;
			this.numLoaded = 1;
			this.hashToIndex = new Map();
			this.hashToIndex.set(zeroString, 0);
		}
	}

	addHashFromBuf(buf, offset) {
		const hash = binToPackedString(buf, offset, this.byteStride);
		return this.addHash(hash);
	}

	addHash(hash) {
		let resid = this.hashToIndex.get(hash);
		if (resid === undefined) {
			resid = this.numLoaded++;
			this.hashToIndex.set(hash, resid);
			this.hashes[resid] = hash;
		}

		return resid;
	}

	addIdAndHash(id, hash) {
		this.hashToIndex.set(hash, id);
		this.hashes[id] = hash;
		this.numLoaded++;
	}

	isEmpty() {
		return this.numLoaded === 1;
	}

}
